// @flow
import { GET_ALL_VIDEOS } from './actionTypes'

export default ({ pagination, filterGroup }) => ({
  type: GET_ALL_VIDEOS,
  payload: {
    pagination,
    filterGroup, // filters, favorites, unFiltered
  }
})